module.exports = __webpack_public_path__ + "static/ongoing-f7cc247b2d3a4dbd2fa76038b92dbf82.png";